import { render, staticRenderFns } from "./ProgressStatementsArticleSummaryTable.vue?vue&type=template&id=01b2203a"
import script from "./ProgressStatementsArticleSummaryTable.vue?vue&type=script&lang=ts"
export * from "./ProgressStatementsArticleSummaryTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports